import './SearchInput.css';
export var searchInput = '_1mumub80-3-5-0';